import { useContext, useState } from "react";
import { NEW_MOCK_CREATE } from "../../Utils/apis";
import { MockInterviewContext } from '../../Contexts/mockInterviewContext.js';

export const useNewMockCreate = () => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState('');
    const { currentMockId, setCurrentMockId } = useContext(MockInterviewContext);

    const submitMock = async (formData) => {
        // console.log("Submitting formData:", formData);
        try {
            setError('');
            setLoading(true);
            const res = await fetch(NEW_MOCK_CREATE, {
                headers: {
                    // 'Content-Type': 'multipart/form-data', // DO NOT SET THIS HEADER WHEN USING FORM DATA
                    "Accept": "application/json"
                },
                method: 'POST',
                // Do NOT set Content-Type header for FormData
                body: formData,
                credentials: 'include',
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.error || 'Unknown error');
            }
            // console.log("Response:", res);
            const data = await res.json();
            // console.log("Response data:", data);
            setCurrentMockId(data?.mock_id);
            setLoading(false);
            return data;
        } catch (err) {
            setError(err.message);
            setLoading(false);
            return Promise.reject(err.message);
        }
    }
    return [loading, error , submitMock];
};